/**
 * A vague type for callback functions used by jQuery AJAX.
 */
type CallbackFunction = (data: unknown) => void;

/**
 * Makes an AJAX request adding a school-level giving donation for ${amount} earmarked for school ${schoolId} to your
 * cart.
 */
export const giveToSchool = (schoolId: number | string, amount: number, monthly: boolean, onSuccess: CallbackFunction, onFail: CallbackFunction) => {
    $.ajax({
        url: secureBaseURL + 'donors/cart/school-donation.json',
        method: 'POST',

        data: {
            schoolId,
            value: amount,
            monthly,
        },
        dataType: 'json',
        xhrFields: {
            // Most callers will hit this URL from WWW
            withCredentials: true,
        },
    }).done((data) => {
        try {
            window.dcAnalytics.track('Added to Shopping Cart', {
                'Page Name': pageName,
                'Add To Cart Price': amount,
                'Gift Code to School': schoolId,
            });
        } catch (e) {
            // Do nothing.
        }

        onSuccess(data);
    }).fail((data) => {
        onFail(data);
    });
};
